import { getCurrentBasic } from './core/ProgramService'

/**
 *
 * @description 资讯 - 浏览
 */
export async function reportNewsView(params: {
    /** 资讯id */
    newsId: string

    /** 资讯标题 */
    newsTitle: string
}) {
    window['sensors'].track(
        'KbPGCObjUserAct',
        Object.assign(await getCurrentBasic(), {
            business: 'NEWS',
            businessVer: 1,
            pageName: '资讯详情页',
            pageUrl: window.location.href,

            ref1Name: '开吧资讯',
            ref1: params.newsId,
            ref1Title: params.newsTitle,

            view: 1,
        }),
    )
}

/**
 *
 * @description 资讯 - 分享
 */
export async function reportNewsShare(params: {
    /** 资讯id */
    newsId: string

    /** 资讯标题 */
    newsTitle: string
}) {
    window['sensors'].track(
        'KbPGCObjUserAct',
        Object.assign(await getCurrentBasic(), {
            business: 'NEWS',
            businessVer: 1,
            pageName: '资讯详情页',
            pageUrl: window.location.href,

            ref1Name: '开吧资讯',
            ref1: params.newsId,
            ref1Title: params.newsTitle,

            share: 1,
        }),
    )
}

/**
 *
 * @description 资讯 - 点赞
 */
export async function reportNewsPraise(params: {
    /** 资讯id */
    newsId: string

    /** 资讯标题 */
    newsTitle: string
}) {
    window['sensors'].track(
        'KbPGCObjUserAct',
        Object.assign(await getCurrentBasic(), {
            business: 'NEWS',
            businessVer: 1,
            pageName: '资讯详情页',
            pageUrl: window.location.href,

            ref1Name: '开吧资讯',
            ref1: params.newsId,
            ref1Title: params.newsTitle,

            like: 1,
        }),
    )
}

/**
 *
 * @description 资讯 - 发帖
 */
export async function reportNewsCreateNote(params: {
    /** 资讯id */
    newsId: string

    /** 资讯标题 */
    newsTitle: string

    /** 发帖的⽂字 */
    noteText?: string

    /** 发帖视频 */
    noteVideo?: unknown[]

    /** 发帖⾳频 */
    noteAudio?: unknown[]

    /** 发帖图⽚ */
    noteImage?: unknown[]
}) {
    const { newsId: ref1, newsTitle: ref1Title, ...rest } = params

    window['sensors'].track(
        'KbPGCObjUserAct',
        Object.assign(await getCurrentBasic(), {
            business: 'NEWS',
            businessVer: 1,
            pageName: '资讯详情页',
            pageUrl: window.location.href,

            ref1Name: '开吧资讯',
            ref1,
            ref1Title,

            note: 1,
            reply: 1,

            noteText: rest.noteText?.length ?? 0,
            noteVideo: rest.noteVideo?.length ?? 0,
            noteAudio: rest.noteAudio?.length ?? 0,
            noteImage: rest.noteImage?.length ?? 0,
        }),
    )
}

/**
 *
 * @description 资讯 - 回复
 */
export async function reportNewsComment(params: {
    /** 资讯id */
    newsId: string

    /** 资讯标题 */
    newsTitle: string

    /** 回复的字符数 */
    commentText: string
}) {
    window['sensors'].track(
        'KbPGCObjUserAct',
        Object.assign(await getCurrentBasic(), {
            business: 'NEWS',
            businessVer: 1,
            pageName: '资讯详情页',
            pageUrl: window.location.href,

            ref1Name: '开吧资讯',
            ref1: params.newsId,
            ref1Title: params.newsTitle,

            reply: 1,
            comment: 1,
            commentText: params.commentText?.length ?? 0,
        }),
    )
}
